import _ from 'lodash'

export enum ANNOTATION_MODE {
  SELECT= "SELECT",
  RECTANGLE = "RECTANGLE",
  POLYGON = "POLYGON",
  CIRCLE = "CIRCLE",
  POINT = "POINT",
}

export enum CREATING_NEW_ANNOTATION_MODE {
  RECTANGLE = "RECTANGLE",
  POINT = "POINT",
}

export enum ANNOTATION_TYPE {
  RECTANGLE = "box",
  POINT = "point",
}

export const ANNOTATION_OUTSIDE_CLICK_PREVENT_CLASS = 'js-prevent-annotations-outside-click'

export const shouldShowAnnotationHighlight = (
  selectedAnnotation: any,
  annotationInProgress: any,
  showOverlay: boolean
) => {
  // Показываем оверлей только для прямоугольных аннотаций (областей), а не для точек
  const isSelectedRectangle = selectedAnnotation && selectedAnnotation.type === ANNOTATION_TYPE.RECTANGLE
  const isCreatingRectangle = annotationInProgress && annotationInProgress.type === ANNOTATION_TYPE.RECTANGLE
  // Показываем оверлей только для графических аннотаций
  const isAnnotationWithCoordinates = isSelectedAnnotationHasCoordinates(selectedAnnotation)
  return showOverlay && ((isAnnotationWithCoordinates && isSelectedRectangle) || isCreatingRectangle)
}

export const getActiveRectangle = (selectedAnnotation: any, annotationInProgress: any) => {
  if (selectedAnnotation && selectedAnnotation.type === ANNOTATION_TYPE.RECTANGLE) {
    const { x, y, width, height } = selectedAnnotation.geometry.absolute
    return { x, y, width, height }
  }
  if (annotationInProgress && annotationInProgress.type === ANNOTATION_TYPE.RECTANGLE) {
    return annotationInProgress
  }
  return null
}

export const transformAnnotationsToShapes = (
  annotations: any[],
  selectedAnnotationId: string,
  fillColor: string
) => {
  return annotations.map((annotation) => {
    const { x, y, width, height } = annotation.geometry.absolute
    const type = annotation.type
    const id = annotation.data.id
    const authorId = annotation.data.authorId
    const isActive = selectedAnnotationId === id
    const authorName = annotation.data.author_name

    switch (annotation.type) {
    case ANNOTATION_TYPE.RECTANGLE:
      return {
        id,
        x,
        y,
        height,
        width,
        type,
        fillColor,
        authorId,
        active: isActive,
        authorName,
      }
    case ANNOTATION_TYPE.POINT:
      return {
        id,
        x,
        y,
        fillColor,
        type,
        authorId,
        active: isActive,
        authorName,
      }
    default:
      return null
    }
  }).filter((annotation) => annotation.active)
}

export const calculateAnnotationCoordinates = (annotation: any, imgWidth: number, imgHeight: number, margin = 0) => {
  const { x, y, width, height, type } = annotation
  const xPosPercent = (x - margin / 2) / imgWidth * 100
  const yPosPercent = (y - margin / 2) / imgHeight * 100
  const x1PosPercent = xPosPercent + width / imgWidth * 100
  const y1PosPercent = yPosPercent + height / imgHeight * 100
  let coordinates = []

  switch (type) {
  case ANNOTATION_TYPE.RECTANGLE:
    coordinates = [xPosPercent, yPosPercent, x1PosPercent, y1PosPercent]
    break
  case ANNOTATION_TYPE.POINT:
    coordinates = [xPosPercent, yPosPercent]
    break
  }

  return {
    coordinates,
    xPosPercent,
    yPosPercent
  }
}

export const isSelectedAnnotationHasCoordinates = (annotation: any) => {
  if (!annotation) return false

  const coordinates = annotation.coordinates || annotation?.data?.annotation?.coordinates || []
  return coordinates.length >= 2 && coordinates[0] >= 0 && coordinates[1] >= 0
}

export const normalizeAnnotationAbsCoordinates = ({ x, y, width, height }) => {
  const annotationX = _.isNaN(x) ? 0 : Math.max(x, 0)
  const annotationY = _.isNaN(y) ? 0 : Math.max(y, 0)
  const annotationWidth = _.isNaN(width) ? 0 : Math.max(width, 0)
  const annotationHeight = _.isNaN(height) ? 0 : Math.max(height, 0)
  return { x:annotationX, y:annotationY, width:annotationWidth, height:annotationHeight }
}
